import { atom } from 'jotai';

type NotifyDialog = {
  open: boolean;
  message?: string;
};

export const notifyDialogAtom = atom<NotifyDialog>({
  open: false,
});

export const numberOfMissedCallsToPauseAtom = atom(0);

export const ringTimeoutAtom = atom(-1);

export const extensionSSEAtom = atom<string | null>(null);
